import { MessageDescriptor } from '@lingui/core'

import { getSentry } from '@emico/utils'

// Avoid reporting many times to avoid rate limiting Sentry
let reportedMissingMessageDescriptor = false
export default function getMessageDescriptor(
  messages: { [key: string]: MessageDescriptor },
  key: string,
) {
  const i18nKey = messages[key]
  if (!i18nKey) {
    if (!reportedMissingMessageDescriptor) {
      const Sentry = getSentry()
      Sentry?.captureMessage(
        `Missing i18n message with key: ${key}`,
        "warning",
      )
      reportedMissingMessageDescriptor = true
    }
    return undefined
  }

  return i18nKey
}
